var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fab_detail.is_show === 1 && _vm.delay_show)?_c('div',{ref:"div",staticClass:"float-btn",style:({
    right: _vm.right + 'px',
    bottom: _vm.bottom + 'px',
  }),on:{"touchstart":(e) => {
      _vm.dragStart(e);
    },"touchend":(e) => {
      _vm.dragEnd(e);
    },"touchmove":function($event){$event.preventDefault();return ((e) => {
      _vm.dragProgress(e);
    }).apply(null, arguments)}}},[(_vm.fab_detail.url)?_c('img',{attrs:{"src":_vm.fab_detail.url},on:{"click":_vm.toFloatDetail}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }